export enum NOTIFICATION_BAR_MOBILE_TEXT_LIMIT {
  NO_CLOSE_NO_CTA = 155,
  WITH_CLOSE_ONLY = 125,
  WITH_CTA_ONLY = 115,
  WITH_CLOSE_CTA = 85,
}
